import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasLoggia = createSelector(selectJsonQuery, jsonQuery => getTermValue('loggia')(jsonQuery));
